"use strict";

import PropTypes from 'prop-types';

export default PropTypes.shape({
    "Left": PropTypes.number.isRequired,
    "Top": PropTypes.number.isRequired
});
